module.exports = __webpack_public_path__ + "img/Sumi_Tapadar.e8b93bd8.jpg";